import type {
  RuntimeRoadControl,
  RuntimeWorldTilePayloadV2,
} from "./schema/runtimeTile.ts";

export type TilePedestrianCrossingSource = RuntimeRoadControl & {
  readonly kind: "crossing";
};

/**
 * Returns the marked crossing controls owned by this tile. The offline source
 * build has already performed the strict OSM-to-GRPK match and retained the
 * road feature ID, projected point and tangent, so runtime rendering never
 * repeats a nearest-road lookup.
 */
export function pedestrianCrossingSourcesForTile(
  tile: Readonly<RuntimeWorldTilePayloadV2>,
): readonly Readonly<TilePedestrianCrossingSource>[] {
  const renderedCrossingIds = new Set(
    (tile.hardscapeAreas ?? [])
      .filter((feature) =>
        feature.classCode.toLowerCase().includes(":crossing-marking:")
      )
      .map((feature) => feature.id.replace(/:marking$/u, "")),
  );
  return (tile.roadControls ?? []).filter(
    (control): control is TilePedestrianCrossingSource =>
      control.kind === "crossing" && control.marked === true &&
      renderedCrossingIds.has(control.id),
  );
}
